import React, { useState } from "react";

export type ToggleSwitchProps = {
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  onChange?: () => void;
  activeText?: string;
  inactiveText?: string;
  loadingText?: string;
  showStateLabel?: boolean;
};

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  disabled = false,
  label = "Toggle switch",
  onChange,
  activeText = "On",
  inactiveText = "Off",
  loadingText = "Updating...",
  showStateLabel = true,
}) => {
  const [internalChecked, setInternalChecked] = useState(false);
  const isControlled = typeof checked === "boolean";
  const isOn = isControlled ? checked : internalChecked;

  const handleChange = () => {
    if (disabled) return;
    if (!isControlled) {
      setInternalChecked((prev) => !prev);
    }
    onChange?.();
  };

  return (
    <label className="inline-flex items-center gap-3 cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={isOn}
        disabled={disabled}
        onChange={handleChange}
        aria-label={label}
      />
      <div className="relative h-6 w-11 rounded-full bg-gray-300 transition-colors peer-checked:bg-green-500 peer-disabled:opacity-50 after:absolute after:left-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-transform after:content-[''] peer-checked:after:translate-x-full" />
      {showStateLabel ? (
        <span className="text-xs font-medium normal-case">
          {disabled ? loadingText : isOn ? activeText : inactiveText}
        </span>
      ) : null}
    </label>
  );
};

export const StatusSwitch: React.FC<ToggleSwitchProps> = (props) => (
  <ToggleSwitch {...props} />
);
